export default [
  {
    type: 'Feature',
    id: 'NOR',
    properties: {name: 'Norway'},
    geometry: {
      type: 'MultiPolygon',
      coordinates: [
        [
          [
            [28.165547, 71.185474],
            [31.293418, 70.453788],
            [30.005435, 70.186259],
            [31.101079, 69.55808],
            [29.399581, 69.156916],
            [28.59193, 69.064777],
            [29.015573, 69.766491],
            [27.732292, 70.164193],
            [26.179622, 69.825299],
            [25.689213, 69.092114],
            [24.735679, 68.649557],
            [23.66205, 68.891247],
            [22.356238, 68.841741],
            [21.244936, 69.370443],
            [20.645593, 69.106247],
            [20.025269, 69.065139],
            [19.87856, 68.407194],
            [17.993868, 68.567391],
            [17.729182, 68.010552],
            [16.768879, 68.013937],
            [16.108712, 67.302456],
            [15.108411, 66.193867],
            [13.55569, 64.787028],
            [13.919905, 64.445421],
            [13.571916, 64.049114],
            [12.579935, 64.066219],
            [11.930569, 63.128318],
            [11.992064, 61.800362],
            [12.631147, 61.293572],
            [12.300366, 60.117933],
            [11.468272, 59.432393],
            [11.027369, 58.856149],
            [10.356557, 59.469807],
            [8.382, 58.313288],
            [7.048748, 58.078884],
            [5.665835, 58.588155],
            [5.308234, 59.663232],
            [4.992078, 61.970998],
            [5.9129, 62.614473],
            [8.553411, 63.454008],
            [10.527709, 64.486038],
            [12.358347, 65.879726],
            [14.761146, 67.810642],
            [16.435927, 68.563205],
            [19.184028, 69.817444],
            [21.378416, 70.255169],
            [23.023742, 70.202072],
            [24.546543, 71.030497],
            [26.37005, 70.986262],
            [28.165547, 71.185474],
          ],
        ],
        [
          [
            [24.72412, 77.85385],
            [22.49032, 77.44493],
            [20.72601, 77.67704],
            [21.41611, 77.93504],
            [20.8119, 78.25463],
            [22.88426, 78.45494],
            [23.28134, 78.07954],
            [24.72412, 77.85385],
          ],
        ],
        [
          [
            [18.25183, 79.70175],
            [21.54383, 78.95611],
            [19.02737, 78.5626],
            [18.47172, 77.82669],
            [17.59441, 77.63796],
            [17.1182, 76.80941],
            [15.91315, 76.77045],
            [13.76259, 77.38035],
            [14.66956, 77.73565],
            [13.1706, 78.02493],
            [11.22231, 78.8693],
            [10.44453, 79.65239],
            [13.17077, 80.01046],
            [13.71852, 79.66039],
            [15.14282, 79.67431],
            [15.52255, 80.01608],
            [16.99085, 80.05086],
            [18.25183, 79.70175],
          ],
        ],
        [
          [
            [25.447625, 80.40734],
            [27.407506, 80.056406],
            [25.924651, 79.517834],
            [23.024466, 79.400012],
            [20.075188, 79.566823],
            [19.897266, 79.842362],
            [18.462264, 79.85988],
            [17.368015, 80.318896],
            [20.455992, 80.598156],
            [21.907945, 80.357679],
            [22.919253, 80.657144],
            [25.447625, 80.40734],
          ],
        ],
      ],
    },
  },
]
